import { Trans } from '@lingui/react';
import {
  OptionsRegistrationDocument,
  useOsrUpdateMutation,
  useOptionsSharesRegistrationSuspenseQuery,
} from '../../../../../graphql/react-operations';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { BvContactForm } from '../../../../../components/BvContactForm';
import React from 'react';

export const StepOptionSharesRegForm = ({ osrId }: { osrId: string }) => {
  const companyId = useCompanyId();

  const [updateOsr, { loading, error }] = useOsrUpdateMutation({ refetchQueries: [OptionsRegistrationDocument] });
  const {
    data: { optionsSharesRegistration },
  } = useOptionsSharesRegistrationSuspenseQuery({ variables: { companyId, id: osrId } });

  return (
    <BvContactForm
      loading={loading}
      error={error}
      submitLabel={<Trans id="Save" />}
      onSave={async data => {
        await updateOsr({
          variables: {
            companyId,
            input: { ...data, id: osrId },
          },
        });
      }}
      defaultValues={optionsSharesRegistration}
    />
  );
};
